import { useContext } from "react";
import { useQuery } from "react-query"
import { CartContext } from "../context/CartContext";
import axios from "axios";



const useUserCart = () => {
    const headers = {
        token: localStorage.getItem("userToken"),
    };
    const getLoggedInUserCart = async () => {
        try {
            const response = await axios.get('https://ecommerce.routemisr.com/api/v1/cart',
                {
                    headers
                })
            return response.data;
        } catch (error) {
            throw error.response.data.message
        }
    }

    return useQuery('cartItems', () => getLoggedInUserCart());
}
export default useUserCart;